require('../../modules/es6.object.get-own-property-names');
var $Object = require('../../modules/_core').Object;
module.exports = function getOwnPropertyNames(it) {
  return $Object.getOwnPropertyNames(it);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/object/get-own-property-names.js
// module id = 1308
// module chunks = 2